export default __webpack_public_path__ + "static/aavegotchi-a25c65dfad69245e37960c24297e2a56.jpg";